"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { differenceInMilliseconds, intervalToDuration } from "date-fns";
import { CalendarClock } from "lucide-react";
import { Badge } from "../ui/badge";
type RegistrationCloseTimerProps = {
  closeDate?: string;
};
export const RegistrationCloseTimer = t0 => {
  const $ = _c(6);
  const {
    closeDate
  } = t0;
  const [timeLeft, setTimeLeft] = useState(null);
  let t1;
  let t2;
  if ($[0] !== closeDate) {
    t1 = () => {
      if (!closeDate) {
        queueMicrotask(() => setTimeLeft(null));
        return;
      }
      const closeMoment = new Date(`${closeDate}T23:59:59`);
      const update = () => {
        const now = new Date();
        const diffMs = differenceInMilliseconds(closeMoment, now);
        if (diffMs <= 0) {
          setTimeLeft(null);
          return;
        }
        const duration = intervalToDuration({
          start: now,
          end: closeMoment
        });
        const days = duration.days || 0;
        const hours = duration.hours || 0;
        const minutes = duration.minutes || 0;
        const seconds = duration.seconds || 0;
        const parts = [];
        if (days > 0) {
          parts.push(`${days}d`);
        }
        parts.push(`${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`);
        setTimeLeft(parts.join(" "));
      };
      update();
      const interval = setInterval(update, 1000);
      return () => clearInterval(interval);
    };
    t2 = [closeDate];
    $[0] = closeDate;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!timeLeft) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CalendarClock size={16} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== timeLeft) {
    t4 = <Badge className="absolute -top-2.5 right-2 z-10 bg-red-50 text-red-700 ring ring-red-700 dark:bg-red-950 dark:text-red-300 dark:ring-red-300" aria-label="Registration closes soon">{t3}<span>Registration closes in <b>{timeLeft}</b></span></Badge>;
    $[4] = timeLeft;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};